module.exports = __webpack_public_path__ + "assets/img/FS.6dc2d6b3.png";